interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  /** Görsel etiket yoksa erişilebilirlik için zorunlu. */
  ariaLabel?: string;
}

/**
 * Erişilebilir aç/kapa switch'i. Native checkbox görsel olarak gizlenir
 * (klavye + focus + form semantiği korunur), üstüne token'lı track+thumb çizilir.
 */
export function ToggleSwitch({ checked, onChange, label, disabled, ariaLabel }: ToggleSwitchProps) {
  return (
    <label className="switch">
      <input
        type="checkbox"
        role="switch"
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel ?? label}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="switch-track" aria-hidden="true"><span className="switch-thumb" /></span>
      {label ? <span>{label}</span> : null}
    </label>
  );
}
